var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftCard1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.6,
    height: 51.882,
    viewBox: "0 0 45.6 51.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gift-card",
    transform: "translate(-31 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M31,120H46.2v6.08H31Z",
    transform: "translate(0 -107.84)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M31,210H46.2v21.28H31Z",
    transform: "translate(0 -188.72)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M331,120h15.2v6.08H331Z",
    transform: "translate(-269.6 -107.84)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M331,231.28h15.2V210H331Zm3.04-9.12h9.12v3.04h-9.12Z",
    transform: "translate(-269.6 -188.72)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M170.665,8.042a4.56,4.56,0,1,0-7.291-4.86L161.64,8.651l-1.734-5.469a4.56,4.56,0,1,0-7.288,4.861l4.869,4.116h-.407V51.882l4.56-4.56,4.56,4.56V12.16h-.407ZM166.271,4.1A1.52,1.52,0,1,1,168.7,5.722l-4.023,3.4Zm-12.231.46a1.52,1.52,0,0,1,2.969-.46L158.6,9.12l-4.02-3.4A1.52,1.52,0,0,1,154.04,4.56Z",
    transform: "translate(-107.84)",
    fill: "#4e3057"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard1);
export default __webpack_public_path__ + "static/media/gift-card_1.9e2a3b3b312aa48a144cebddf3a0971d.svg";
export { ForwardRef as ReactComponent };